/* MundoParquet — W6.7 (decisió Alex 10-07): els links de contingut informatiu
   (pàgines, blog, legals) obren en pestanya nova a tota la web. El flux de
   compra (col·leccions, productes, carret, checkout) es queda a la mateixa
   pestanya. Els externs ja porten target des del Liquid. */
(() => {
  'use strict';

  const INFO_PREFIXES = ['/pages/', '/blogs/', '/policies/'];

  const apply = (root) => {
    root.querySelectorAll('a[href]').forEach((a) => {
      if (a.target) return;
      const href = a.getAttribute('href');
      if (!href) return;
      if (INFO_PREFIXES.some((p) => href.startsWith(p))) {
        a.target = '_blank';
        a.rel = a.rel ? a.rel + ' noopener' : 'noopener';
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply(document));
  } else {
    apply(document);
  }
})();
